import React, { useState, useEffect } from 'react';

import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap';

import dateFormat from 'dateformat';

import { Utilities } from '../../MedicareProAPI/Utilities/Utilities';
import { SideTab } from '../Components/SideTab';
import AgentEventCalendarPanel from '../Panels/AgentEventCalendarPanel';

export default function CalendarButton(props) {
  const [show, setShow] = useState(false);

  return (
    <>
      <a
        onClick={(e) => {
          setShow(true);
        }}
        className="nav-link"
        href="#"
      >
        <OverlayTrigger placement="top" overlay={<Tooltip placement="right">Calendar</Tooltip>}>
          <i className="fas fa-calendar mt-1 text-primary" style={{ fontSize: '13pt' }}></i>
        </OverlayTrigger>
      </a>

      <SideTab
        size="lg"
        position="right"
        title="Calendar"
        onClose={(e) => setShow(false)}
        show={show}
        scroll={false}
        id={'sidetab-calendar'}
      >
        {show && <AgentEventCalendarPanel {...props} />}
      </SideTab>
    </>
  );
}
